/**
 * @file 接口配置
 * @author svon.me@gmail.com
 */
// @ts-ignore
import URL from "url";
import Config from "@/config";
import * as _ from "lodash-es";
// @ts-ignore
import tool from '@/utils/tool';
import {API} from "@js-lion/api";
// @ts-ignore
import * as abnormal from "./abnormal";
// @ts-ignore
import * as transform from "./transform";

import safeGet from "@fengqiaogang/safe-get";
import {SYSTEM_NAME, SYSTEM_API_BASIS} from "@/config/app";

import type {AxiosRequestConfig} from "axios";

API.setEnv({
  // 配置全局的变量，用于 url 宏变量替换
});

API.setConfig({
  baseURL: Config.API_URL, // 默认接口地址
  timeout: Config.TIMEOUT, // 默认超时时长
});

const isBaseURLProxy = function (value: string): boolean {
  return /^(https?:)?\/\/[a-z0-9]+\.[a-z0-9]+/i.test(value);
}

// 请求前拦截
API.addRequest(function (request: AxiosRequestConfig) {
  // 系统登录认证
  if (request.url && request.url.includes("/lqa-game/oauth/token")) {
    // 请求前处理
    return request;
  }
  const app = safeGet<string>(request.params, "app");
  if (app && _.hasIn(SYSTEM_NAME, app)) {
    const value: string = SYSTEM_API_BASIS[app];
    // 接口代理地址
    const proxy: string = Config.env.VITE_APP_API_BASEURL;
    if (value && isBaseURLProxy(proxy)) {
      const reg = /^\/[\w-]+\//i;
      const url = URL.parse(request.url || "/", true);
      // 变更请求路径的第一段
      url.pathname = String(url.pathname || "/").replace(reg, `/${value}/`);
      request.url = URL.format(url);
    } else if (value) {
      const text: string = `${proxy}/${value}/`;
      const reg = new RegExp(`${proxy}/[\\w-]+\/`, "i");
      // 通过正则的方式匹配请求路径，并替换
      request.url = String(request.url || "/").replace(reg, text);
    }
  }
  const token = tool.cookie.get(Config.TOKEN_KEY);
  if (token) {
    const headers = request.headers || {};
    headers[Config.TOKEN_NAME] = Config.TOKEN_PREFIX + token;
    request.headers = headers;
  }
  // 如果不启用缓存
  if (!Config.REQUEST_CACHE && _.toUpper(request.method) === "GET") {
    const params = request.params || {};
    params['_'] = Date.now();
    request.params = params;
  }
  return request;
});

// 响应前拦截
API.addResponse(function (response): any {
  const code = Number(safeGet(response.data, 'code') || safeGet(response.data, 'scode'));
  if (code === 200 || code === 502) {
    return transform.response(response);
  }
  if (code == 401) {
    setTimeout(abnormal.E401);
    return Promise.reject(response);
  }
  if (code === 404) {
    const tips = safeGet(response, "data.msg");
    if (tips && tips.includes("路径不存在")) {
      return Promise.reject(response);
    } else {
      // 调整到 404 页面
      window.location.href = Config.EMPTY_URL;
      return Promise.reject(response);
    }
  }
  if (code === 500) {
    const result = transform.response(response);
    abnormal.E500(result);
    return Promise.reject(result);
  }
  return response;
}, function (error) {
  const response = error.response;
  const status = safeGet(response, "status");
  if (status && status === 401) {
    setTimeout(abnormal.E401);
    return Promise.reject(response);
  }

  if (status && status === 404) {
    abnormal.E404();
    return Promise.reject(response);
  }

  if (status && status === 500) {
    const result = transform.response(response);
    abnormal.E500(result);
    return Promise.reject(response);
  }
  return Promise.reject(response ? response : error);
});